<template>
  <div>
    <div class="pa-4">
      <v-row justify="space-between">
        <v-col v-if="!noHeader">
          <div class="font-weight-bold basic--text text-center">{{ 'Application complete'.toUpperCase() }}</div>
        </v-col>
      </v-row>

      <v-row class="mt-8" justify="center">
        <v-col cols="12" md="6">
          <v-card outlined rounded>
            <v-card-text v-if="!noHeader">
              <v-alert type="info">Application complete!!!</v-alert>

              <v-btn depressed color="primary" width="100%" @click="downloadApplicationSummary">Application Summary</v-btn>
              <v-btn depressed color="primary" width="100%" class="mt-4" @click="downloadApplicationFeeInvoice" v-if="getApplicantFee != null">Application invoice</v-btn>
              <v-btn depressed color="primary" width="100%" class="mt-4" @click="downloadScreeningInvoice" v-if="getScreeningFee != null">Screening invoice</v-btn>
              <v-btn depressed color="primary" width="100%" class="mt-4" @click="downloadScreeningForm" v-if="hasScreeningForm && hasAcceptedAdmission">Screening Form</v-btn>
              <v-btn depressed color="primary" width="100%" class="mt-4" @click="downloadRegistrationProcedure">Registration Process</v-btn>
              <v-btn v-for="(item, index) in documents" :key="'doc-'+index" depressed color="primary" width="100%" class="mt-4" @click="downloadDocument(item)">{{item.name}}</v-btn>

              <v-alert type="info" class="my-4">
                <div>Always check your dashboard to track your status or scan the QR code on any of the documents you had/will download from this page.</div>
                <div class="mt-2">Congratulations!</div>
              </v-alert>
            </v-card-text>
            <v-card-text v-else>
              <div class="text-center d-flex flex-column">
                <div>
                  <v-icon color="primary" size="50">mdi-clipboard-check-outline</v-icon>
                </div>
                <h4 class="primary--text my-2">Application complete</h4>
              </div>
              <v-divider class="mb-4"></v-divider>

              <div class="mt-2 text-center black--text">To keep track of your progress, check your dashboard frequently, or scan the QR code on any documents you have downloaded or plan to download from this page.</div>
              <div class="mt-2 text-center black--text">Congratulations!</div>

              <v-row justify="space-between" class="mt-6">
                <v-col cols="12" md="6" class="mt-0 mb-0">
                  <v-btn depressed color="primary" width="100%" class="mt-2" @click="downloadApplicationSummary">Application Summary</v-btn>
                </v-col>
                <v-col cols="12" md="6" v-if="getApplicantFee != null" class="mt-0 mb-0">
                  <v-btn depressed color="primary" width="100%" class="mt-2" @click="downloadApplicationFeeInvoice">Application invoice</v-btn>
                </v-col>
                <v-col cols="12" md="6" v-if="getScreeningFee != null" class="mt-0 mb-0">
                  <v-btn depressed color="primary" width="100%" class="mt-2" @click="downloadScreeningInvoice" >Screening invoice</v-btn>
                </v-col>
                <v-col cols="12" md="6" v-if="hasScreeningForm && hasAcceptedAdmission" class="mt-0 mb-0">
                  <v-btn depressed color="primary" width="100%" class="mt-2" @click="downloadScreeningForm" >Screening Form</v-btn>
                </v-col>
                <v-col cols="12" md="6" class="mt-0 mb-0">
                  <v-btn depressed color="primary" width="100%" class="mt-2" @click="downloadRegistrationProcedure">Registration Process</v-btn>
                </v-col>
                <v-col v-for="(item, index) in documents" :key="'doc2-'+index" cols="12" md="6" class="mt-0 mb-0">
                  <v-btn depressed color="primary" width="100%" class="mt-2" @click="downloadDocument(item)">{{item.name}}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>


      <loading-dialog :show="loading"></loading-dialog>
      <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Api from '@/main/api';
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ErrorResolver from '@/shared/ErrorResolver';
import StudentStatus from "@/shared/StudentStatus";

//the file is in pdf
const handlefiledownload = async (blob, title) => {
  const link = document.createElement('a')
  const data = window.URL.createObjectURL(blob)
  link.href = data;
  link.download = title + '.pdf';

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );
  document.body.appendChild(link)

  link.remove();
}


export default {
  name: "ApplicationComplete",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data: () => ({
    messageShow: false,
    loading: false,
    message: '',
    messageType: '',
    documents: []
  }),

  computed: {
    ...mapGetters(['getUser', 'getApplicantFee', 'getScreeningFee']),
    hasScreeningForm: function(){
      return this.getUser != null && this.getUser.admission.applicationType.screeningForm != null
    },

    hasAcceptedAdmission: function () {
      return this.getUser != null &&
          (this.getUser.studentStatus === StudentStatus.ADMISSION_ACCEPTED.text || this.getUser.studentStatus === StudentStatus.CLEARED.text
              || this.getUser.studentStatus === StudentStatus.STUDENT.text);
    },
  },

  methods: {
    downloadApplicationSummary(){
      this.loading = true;
      Api.applicants.applicationSummary(this.getUser.userId)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'application-summary.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    downloadScreeningForm(){
      this.loading = true;
      Api.applicants.screeningForm(this.getUser.userId)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'screening-form.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    downloadApplicationFeeInvoice(){
      this.loading = true;
      Api.applicants.applicationInvoice(this.getUser.id)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    downloadScreeningInvoice(){
      this.loading = true;
      Api.applicants.screeningInvoice(this.getUser.id)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      }).finally(() => this.loading = false)
    },

    downloadRegistrationProcedure(){
      this.loading = true
      Api.defaultDocument.getDocument('registration_procedure', this.getUser.programme.programmeType.id)
        .then((res) => {
          let blob = res.data;
          handlefiledownload(blob, 'registration_procedure') //download to pdf file
        }).catch((err) => {ErrorResolver.checkErrors(this, err)
          // TODO: Add error message
        }).finally(() => this.loading = false)
    },

    fetchAllDocuments() {
      if(!this.getUser || !this.getUser.programme)
        return;

      this.loading = true;
      Api.portalDocument.all(this.getUser.programme.programmeType.id, 0, 100).then((res) => {
        this.documents = res.data.content.filter(e => e.programmeType != null && e.forApplicant === true);
      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    downloadDocument(item){
      this.loading = true;
      Api.portalDocument.download(item.link).then((res) => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        let fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute("download", item.name + '.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
        fileLink.remove();
      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    }
  },

  created() {
    this.noHeader && this.$emit('update-title', "Application Complete")
    this.fetchAllDocuments()
  },

  watch: {
    getUser: function(val){
      if(val)
        this.fetchAllDocuments()
    }
  }

}
</script>

<style scoped>

</style>
